export function getFormatedDate(currentDate) {
    currentDate = new Date(currentDate);
    return (
      currentDate.getMonth() +
      1 +
      "/" +
      currentDate.getDate() +
      "/" +
      currentDate.getFullYear()
    );
  }